import { z } from 'zod';
import { EmailSchema, IDSchema, IsoTimestampSchema, SchemaVersionSchema, } from './shared.js';
export const PushSubscriptionSchema = z.object({
    id: IDSchema,
    type: z.literal('push_subscription'),
    schemaVersion: SchemaVersionSchema,
    userEmail: EmailSchema,
    endpoint: z.string().url(),
    p256dhKey: z.string(),
    authKey: z.string(),
    userAgent: z.string().optional(),
    createdAt: IsoTimestampSchema,
    // T1-012 — added alongside Drizzle schema to keep Zod-Drizzle drift checker green.
    updatedAt: IsoTimestampSchema,
    lastUsedAt: IsoTimestampSchema.optional(),
    failureCount: z.number().int().nonnegative().default(0),
    deletedAt: IsoTimestampSchema.nullable().optional(),
    version: z.number().int().positive(),
});
/**
 * T1-055M.1 (T1-055I §B.1) — W3C Push API standard create-input shape.
 *
 * The W3C `PushSubscription.toJSON()` returns:
 *   { endpoint, keys: { p256dh, auth }, expirationTime: number | null }
 *
 * Frontend SPAs call `pushManager.subscribe()` then pass that JSON
 * directly to `POST /api/v1/push/subscribe`. The previous flat shape
 * (`p256dhKey` / `authKey`) required frontend-side mapping; the route
 * now accepts the W3C structure as-is. The route handler unwraps
 * `keys.p256dh` / `keys.auth` into the flat DB columns (`p256dh_key` /
 * `auth_key`) at the boundary; DB normalization is preserved.
 *
 * Consumers: backend route `routes/push.ts` (Fastify JSON schema mirrors
 * this Zod shape); frontend typed clients generated from the OpenAPI
 * snapshot (`packages/shared/openapi.json`).
 */
export const PushSubscriptionCreateInputSchema = z.object({
    endpoint: z.string().url().max(2048),
    keys: z.object({
        p256dh: z.string().max(200),
        auth: z.string().max(200),
    }),
    userAgent: z.string().max(512).optional(),
});
//# sourceMappingURL=push-subscription.js.map